import React, { Component, ErrorInfo, ReactNode } from 'react';

interface ErrorBoundaryProps {
    children: ReactNode;
    fallback?: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true };
    }

    override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Error caught by error boundary:', error, errorInfo);
        // You can also log the error to an error reporting service
    }

    triggerError = (error: Error, scope?: string) => {
        console.warn('Error triggered from:', scope);
        console.error('Error triggered manually:', error);
        this.setState({ hasError: true });
    };

    override render() {
        if (this.state.hasError) {
            return <h1>Something went wrong. Please try again.</h1>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
